export default __webpack_public_path__ + "static/media/groupware-crm 1.1ff7e13c.png";